export default __webpack_public_path__ + "static/media/pdf.fdc83be7.pdf";